import React from "react";

import { ReactComponent as CheckMark } from "../../../../assets/icons/check-mark.svg";
import { ReactComponent as XMark } from "../../../../assets/icons/x-mark.svg";

import "./MembershipFeatureItem.css";

export default function MembershipFeatureItem(props) {
  const mark = props.included ? (
    <CheckMark className="feature-icon" fill="green" />
  ) : (
    <XMark className="feature-icon" fill="red" />
  );

  const featureClass = props.included
    ? "feature-included"
    : "feature-not-included";

  return (
    <div className={"membership-feature-item " + featureClass}>
      {mark} {props.feature}
    </div>
  );
}
